// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"494fb7fb","840":"63cb917b"}[chunkId] + ".chunk.js";
};